import { Shipping_Item_Batch } from "../../models/RestModels";

export function getEmptyShippingItemBatch(): Shipping_Item_Batch
{
		return {
			id: 0,
			shipping_item_id: 0,
			batch: '',
			expiration_date: null,
			qty: 0,
			received_qty: null,
			shrinkage_qty: null,
			created: new Date(),
			updated: new Date()
		};
}
